<script setup lang="ts">
import type { RouteLocationGeneric } from 'vue-router'
import NavigateBackwards from '../layout/NavigateBackwards.vue'

defineProps<{
  backTo?: Partial<RouteLocationGeneric> & { buttonText: string }
  bgColor?: string
  ignoreMaxWidth?: boolean
}>()
</script>

<template>
  <header :class="{ 'max-width': !ignoreMaxWidth }">
    <div>
      <CommonButton
        href="#hoved"
        class="skip-button"
        decoration="fill"
        shape="square"
      >
        {{ $t('app.skipToContent') }}
      </CommonButton>
      <div class="left">
        <ModusHomeLink class="home-link" />
      </div>
      <HeaderActionButtons />
    </div>
    <div class="bottom-row">
      <slot name="bottom-left">
        <NavigateBackwards
          v-if="backTo"
          :to="backTo as RouteLocationGeneric"
          :button-text="backTo.buttonText"
          class="back-button"
        />
      </slot>
      <slot name="bottom-right" />
    </div>
  </header>
</template>

<style lang="scss" scoped>
  header {
    z-index: 999;
    display: flex;
    gap: 32px;
    justify-self: center;
    flex-direction: column;
    padding: 40px 24px;
    width: 100%;
    background-color: v-bind(bgColor);

    &.max-width {
      max-width: var(--app-max-width);
    }

    @include vgs-media-tablet {
      padding: 24px;
    }

    @include vgs-media-mobile {
      padding: 16px;
    }
  }

  header div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .skip-button {
    position: absolute;
    left: -100%;
    transition: none;
    z-index: 100;

    &:focus-visible {
      top: 0;
      left: 0;
    }
  }
</style>
